export default __webpack_public_path__ + "static/media/desktop_tc3_Cn.0833474f.webp";